import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function FinancialReporting() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className=" p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Finance and Accounting</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/billing-invoicing')}
              className="btn "
            >
              Billing and Invoicing
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/finance/accounts-receivable-payable')
              }
              className="btn "
            >
              Accounts Receivable/Payable
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/financial-reporting')}
              className="btn text-black font-bold"
            >
              Financial Reporting
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/tax-management')}
              className="btn "
            >
              Tax Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/audit-logs')}
              className="btn "
            >
              Audit Logs
            </button>
          </div>
        </header>

        <ComingSoon />
      </div>
    </div>
  );
}

export default FinancialReporting;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// function FinancialReporting() {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gray-100">
//       <div className="p-6">
//         <header className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg shadow-sm">
//           <h1 className="text-black text-xl font-bold">Finance and Accounting</h1>
//           <div className="flex space-x-6">
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/billing-invoicing")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Billing and Invoicing
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/accounts-receivable-payable")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Accounts Receivable/Payable
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/financial-reporting")}
//               className="text-black font-bold border-b-2 border-black pb-1"
//             >
//               Financial Reporting
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/tax-management")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Tax Management
//             </button>
//           </div>
//         </header>

//         <FinancialReportingDashboard />
//       </div>
//     </div>
//   );
// }

// // Financial Reporting Component
// function FinancialReportingDashboard() {
//   const [filters, setFilters] = useState({
//     dateRange: 'last-30-days',
//     department: '',
//     customerType: '',
//     reportType: 'summary'
//   });

//   // Sample financial data
//   const financialData = {
//     summary: {
//       totalRevenue: 125450.00,
//       totalExpenses: 89450.00,
//       profitMargin: 28.7,
//       cashFlow: 36000.00
//     },
//     revenueTrend: [
//       { month: 'Jan', revenue: 115000, expenses: 82000 },
//       { month: 'Feb', revenue: 118000, expenses: 84000 },
//       { month: 'Mar', revenue: 122000, expenses: 86000 },
//       { month: 'Apr', revenue: 125450, expenses: 89450 },
//       { month: 'May', revenue: 128000, expenses: 91000 }
//     ],
//     expenseBreakdown: [
//       { category: 'Staff & Labor', amount: 35000, percentage: 39.1 },
//       { category: 'Food & Beverage', amount: 18500, percentage: 20.7 },
//       { category: 'Utilities', amount: 12500, percentage: 14.0 },
//       { category: 'Maintenance', amount: 8500, percentage: 9.5 },
//       { category: 'Marketing', amount: 6500, percentage: 7.3 },
//       { category: 'Other', amount: 8450, percentage: 9.4 }
//     ],
//     departmentProfit: [
//       { department: 'Rooms', revenue: 85400, expenses: 28500, profit: 56900 },
//       { department: 'Food & Beverage', revenue: 28500, expenses: 18500, profit: 10000 },
//       { department: 'Events', revenue: 11500, expenses: 4500, profit: 7000 },
//       { department: 'Spa & Wellness', revenue: 4500, expenses: 2500, profit: 2000 }
//     ]
//   };

//   const reports = [
//     {
//       id: 1,
//       name: 'Monthly Profit & Loss',
//       period: 'April 2024',
//       status: 'Generated',
//       generatedDate: '2024-05-01',
//       type: 'P&L'
//     },
//     {
//       id: 2,
//       name: 'Balance Sheet',
//       period: 'Q1 2024',
//       status: 'Generated',
//       generatedDate: '2024-04-01',
//       type: 'Balance'
//     },
//     {
//       id: 3,
//       name: 'Cash Flow Statement',
//       period: 'March 2024',
//       status: 'Generated',
//       generatedDate: '2024-04-05',
//       type: 'CashFlow'
//     },
//     {
//       id: 4,
//       name: 'Revenue Analysis',
//       period: 'Last 90 Days',
//       status: 'Pending',
//       generatedDate: '',
//       type: 'Revenue'
//     },
//     {
//       id: 5,
//       name: 'Expense Breakdown',
//       period: 'April 2024',
//       status: 'Generated',
//       generatedDate: '2024-05-02',
//       type: 'Expense'
//     }
//   ];

//   const aiInsights = [
//     "Expected revenue increase of 8% next month based on booking trends",
//     "Food & Beverage expenses are 5% above industry average - consider supplier negotiations",
//     "Room occupancy rates showing positive correlation with marketing spend",
//     "Consider adjusting staffing levels during weekdays to optimize labor costs"
//   ];

//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({ ...prev, [key]: value }));
//   };

//   const handleGenerateReport = () => {
//     console.log('Generating report with filters:', filters);
//     // Implementation for generating report
//   };

//   const handleDownloadReport = (reportId) => {
//     console.log('Downloading report:', reportId);
//     // Implementation for downloading report
//   };

//   const handleGenerateNew = (reportType) => {
//     console.log('Generating new report:', reportType);
//     // Implementation for generating new report
//   };

//   // Simple chart components
//   const RevenueTrendChart = () => (
//     <div className="bg-gray-50 p-4 rounded-lg">
//       <h4 className="text-black font-semibold mb-4">Revenue Trend</h4>
//       <div className="flex items-end justify-between h-40">
//         {financialData.revenueTrend.map((month, index) => (
//           <div key={month.month} className="flex flex-col items-center flex-1 mx-1">
//             <div className="flex flex-col items-center flex-1 w-full max-w-16">
//               <div className="flex items-end justify-center w-full space-x-1">
//                 <div
//                   className="bg-green-600 w-6 rounded-t transition-all duration-300"
//                   style={{ height: `${(month.revenue / 130000) * 100}%` }}
//                 ></div>
//                 <div
//                   className="bg-red-500 w-6 rounded-t transition-all duration-300"
//                   style={{ height: `${(month.expenses / 130000) * 100}%` }}
//                 ></div>
//               </div>
//               <span className="text-xs text-dark-gray mt-2">{month.month}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//       <div className="flex justify-center space-x-4 mt-4">
//         <div className="flex items-center">
//           <div className="w-3 h-3 bg-green-600 rounded mr-2"></div>
//           <span className="text-sm text-dark-gray">Revenue</span>
//         </div>
//         <div className="flex items-center">
//           <div className="w-3 h-3 bg-red-500 rounded mr-2"></div>
//           <span className="text-sm text-dark-gray">Expenses</span>
//         </div>
//       </div>
//     </div>
//   );

//   const ExpensePieChart = () => (
//     <div className="bg-gray-50 p-4 rounded-lg">
//       <h4 className="text-black font-semibold mb-4">Expense Breakdown</h4>
//       <div className="flex flex-col space-y-3">
//         {financialData.expenseBreakdown.map((expense, index) => (
//           <div key={expense.category} className="flex items-center justify-between">
//             <div className="flex items-center">
//               <div
//                 className="w-3 h-3 rounded mr-2"
//                 style={{
//                   backgroundColor: [
//                     '#3B82F6', '#EF4444', '#10B981', '#F59E0B', '#8B5CF6', '#6B7280'
//                   ][index]
//                 }}
//               ></div>
//               <span className="text-sm text-dark-gray">{expense.category}</span>
//             </div>
//             <div className="text-right">
//               <div className="text-black font-medium">${expense.amount.toLocaleString()}</div>
//               <div className="text-xs text-dark-gray">{expense.percentage}%</div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   const DepartmentProfitChart = () => (
//     <div className="bg-gray-50 p-4 rounded-lg">
//       <h4 className="text-black font-semibold mb-4">Department-wise Profit</h4>
//       <div className="space-y-3">
//         {financialData.departmentProfit.map((dept, index) => (
//           <div key={dept.department}>
//             <div className="flex justify-between text-sm mb-1">
//               <span className="text-dark-gray">{dept.department}</span>
//               <span className="text-black font-medium">${dept.profit.toLocaleString()}</span>
//             </div>
//             <div className="w-full bg-gray-200 rounded-full h-2">
//               <div
//                 className="bg-blue-600 h-2 rounded-full"
//                 style={{ width: `${(dept.profit / 56900) * 100}%` }}
//               ></div>
//             </div>
//             <div className="flex justify-between text-xs text-dark-gray mt-1">
//               <span>Revenue: ${dept.revenue.toLocaleString()}</span>
//               <span>Expenses: ${dept.expenses.toLocaleString()}</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-6">
//       {/* Filters and Generate Report Button */}
//       <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4">
//         <div className="flex flex-wrap gap-4">
//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.dateRange}
//             onChange={(e) => handleFilterChange('dateRange', e.target.value)}
//           >
//             <option value="last-7-days">Last 7 Days</option>
//             <option value="last-30-days">Last 30 Days</option>
//             <option value="last-90-days">Last 90 Days</option>
//             <option value="this-month">This Month</option>
//             <option value="last-month">Last Month</option>
//             <option value="this-quarter">This Quarter</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.department}
//             onChange={(e) => handleFilterChange('department', e.target.value)}
//           >
//             <option value="">All Departments</option>
//             <option value="rooms">Rooms</option>
//             <option value="f&b">Food & Beverage</option>
//             <option value="events">Events</option>
//             <option value="spa">Spa & Wellness</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.customerType}
//             onChange={(e) => handleFilterChange('customerType', e.target.value)}
//           >
//             <option value="">All Customer Types</option>
//             <option value="corporate">Corporate</option>
//             <option value="leisure">Leisure</option>
//             <option value="group">Group</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.reportType}
//             onChange={(e) => handleFilterChange('reportType', e.target.value)}
//           >
//             <option value="summary">Summary Report</option>
//             <option value="detailed">Detailed Report</option>
//             <option value="comparative">Comparative Analysis</option>
//           </select>
//         </div>

//         <button
//           onClick={handleGenerateReport}
//           className="bg-black text-white px-6 py-2 rounded-lg font-semibold hover:bg-gray-800 transition-colors w-full lg:w-auto"
//         >
//           Generate Report
//         </button>
//       </div>

//       {/* KPI Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Total Revenue</h3>
//           <p className="text-black text-2xl font-bold">${financialData.summary.totalRevenue.toLocaleString()}</p>
//           <p className="text-green-600 text-sm mt-1">+12.5% from last month</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Total Expenses</h3>
//           <p className="text-black text-2xl font-bold">${financialData.summary.totalExpenses.toLocaleString()}</p>
//           <p className="text-red-600 text-sm mt-1">+8.2% from last month</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Profit Margin</h3>
//           <p className="text-black text-2xl font-bold">{financialData.summary.profitMargin}%</p>
//           <p className="text-green-600 text-sm mt-1">+2.1% improvement</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Cash Flow</h3>
//           <p className="text-black text-2xl font-bold">${financialData.summary.cashFlow.toLocaleString()}</p>
//           <p className="text-green-600 text-sm mt-1">Positive</p>
//         </div>
//       </div>

//       {/* Charts Section */}
//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
//         <div className="lg:col-span-2">
//           <RevenueTrendChart />
//         </div>
//         <div className="space-y-6">
//           <ExpensePieChart />
//           <DepartmentProfitChart />
//         </div>
//       </div>

//       {/* Reports Table */}
//       <div className="mb-6">
//         <h3 className="text-black font-semibold mb-4">Available Reports</h3>
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead>
//               <tr className="border-b border-light-gray">
//                 <th className="text-left py-3 px-4 font-semibold text-black">Report Name</th>
//                 <th className="text-left py-3 px-4 font-semibold text-black">Period</th>
//                 <th className="text-left py-3 px-4 font-semibold text-black">Status</th>
//                 <th className="text-left py-3 px-4 font-semibold text-black">Generated Date</th>
//                 <th className="text-left py-3 px-4 font-semibold text-black">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reports.map((report, index) => (
//                 <tr
//                   key={report.id}
//                   className={`border-b border-light-gray ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
//                 >
//                   <td className="py-3 px-4 text-black font-medium">{report.name}</td>
//                   <td className="py-3 px-4 text-dark-gray">{report.period}</td>
//                   <td className="py-3 px-4">
//                     <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
//                       report.status === 'Generated'
//                         ? 'bg-green-100 text-green-800'
//                         : 'bg-yellow-100 text-yellow-800'
//                     }`}>
//                       {report.status}
//                     </span>
//                   </td>
//                   <td className="py-3 px-4 text-dark-gray">{report.generatedDate || '-'}</td>
//                   <td className="py-3 px-4">
//                     <div className="flex space-x-2">
//                       {report.status === 'Generated' ? (
//                         <button
//                           onClick={() => handleDownloadReport(report.id)}
//                           className="bg-black text-white px-3 py-1 rounded text-sm font-medium hover:bg-gray-800 transition-colors"
//                         >
//                           Download
//                         </button>
//                       ) : (
//                         <button
//                           onClick={() => handleGenerateNew(report.type)}
//                           className="bg-black text-white px-3 py-1 rounded text-sm font-medium hover:bg-gray-800 transition-colors"
//                         >
//                           Generate New
//                         </button>
//                       )}
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* AI Insights Section */}
//       <div className="bg-gray-50 rounded-lg p-6 border border-light-gray">
//         <h3 className="text-black font-semibold mb-4">AI Insights & Recommendations</h3>
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {aiInsights.map((insight, index) => (
//             <div key={index} className="bg-white rounded-lg p-4 border border-light-gray">
//               <p className="text-black italic text-sm leading-relaxed">"{insight}"</p>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default FinancialReporting;
